import { UserOutlined } from '@ant-design/icons'
import { Avatar, Flex, List } from 'antd'
import { useTheme } from 'antd-style'
import { PropsWithChildren, useMemo } from 'react'

import { GetListPotentialContactResponseItem } from 'src/api/requests'
import { Text } from 'src/components'
import { CaseStatusTag } from 'src/features/persons/components/CaseStatusTag'
import { getFullName } from 'src/features/users/utils'

import { useStyles } from './styles'

type Props = PropsWithChildren<{
  contact: GetListPotentialContactResponseItem
}>

export const ContactsListItem = ({ contact, children }: Props) => {
  const { styles } = useStyles()
  const palette = useTheme()

  const { comments, contactDate, person } = contact

  const fullName = useMemo(
    () => getFullName(person?.firstName, person?.lastName),
    [person?.firstName, person?.lastName]
  )

  return (
    <List.Item>
      <Flex gap={16} align="center" className="full-width">
        <Flex>
          <Avatar icon={<UserOutlined />} />
        </Flex>

        <Flex justify="space-between" align="center" className="full-width">
          <Flex vertical justify="center">
            <Flex gap={12} align="center">
              <Text strong>{fullName}</Text>
              <CaseStatusTag status={person?.caseStatus} />
              <Text size="md" color={palette.grey.grey1}>
                {contactDate}
              </Text>
            </Flex>

            <Text
              size="md"
              className={styles.comments}
              color={palette.grey.grey1}
            >
              {comments}
            </Text>
          </Flex>

          {children}
        </Flex>
      </Flex>
    </List.Item>
  )
}
